<template>
	<!--新增对话框-->
	<el-dialog title="新增优惠券" :visible.sync="dialogVisible" width="800" :close-on-click-modal="false"
		:before-close="handleClose">

		<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">
			<el-form-item label="优惠券" prop="waysObtain" label-width="150px">
				<el-select v-model="editForm.waysObtain" clearable placeholder="优惠券">
					<el-option label="单笔消费满多少送" value="1"></el-option>
					<el-option label="新用户注册" value="2"></el-option>
					<el-option label="活动赠送券" value="3"></el-option>

				</el-select>
			</el-form-item>
			<el-form-item label="单笔满多少送(元)" v-if="editForm.waysObtain == 1" prop="waysObtainMoney" label-width="150px">
				<el-input v-model="editForm.waysObtainMoney" autocomplete="off" type="number"></el-input>
			</el-form-item>
			<el-form-item label="名称" prop="couponsName" label-width="150px">
				<el-input v-model="editForm.name" autocomplete="off"></el-input>
			</el-form-item>
			<!-- <el-form-item label="面向用户" prop="userOriented" label-width="150px">
				<el-radio-group v-model="editForm.userOriented">
					<el-radio :label="1">所有用户</el-radio>
					<el-radio :label="2">新用户</el-radio>
				</el-radio-group>
			</el-form-item> -->
			<!-- <el-form-item label="有效期类型" prop="userOriented" label-width="150px">
				<el-radio-group v-model="editForm.timeLimitType">
					<el-radio :label="0">无时间限制</el-radio>
					<el-radio :label="1">领取时间限制</el-radio>
				</el-radio-group>
			</el-form-item> -->
			<el-form-item label="有效期(/天)" prop="endTime" label-width="150px">
				<el-input v-model="editForm.validTime" autocomplete="off" type="number"></el-input>
				<!-- <el-date-picker
                        v-model="editForm.termValidity"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        >
                </el-date-picker> -->
			</el-form-item>
			<!-- <el-form-item label="优惠券数量" prop="amount" label-width="150px" v-if="editForm.newcomerCoupon==4&&editForm.isQuantityLimit==1">
                <el-input v-model="editForm.amount" autocomplete="off" type="number" @input="weihechangge($event)"></el-input>
            </el-form-item> -->
			<el-form-item label="优惠规则类型" prop="rulesType" label-width="150px">
				<el-radio-group v-model="editForm.type" @change="rulesTypeChange">
					<el-radio :label="1">无门槛</el-radio>
					<el-radio :label="2">满减</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="优惠金额(元)" prop="discountAmount" label-width="150px">
				<el-input v-model="editForm.discountAmount" autocomplete="off" type="number"></el-input>
			</el-form-item>
			<el-form-item label="满减条件金额(元)" prop="satisfyAmount" label-width="150px" v-if="editForm.type == 2">
				<el-input v-model="editForm.satisfyAmount" autocomplete="off" type="number"></el-input>
			</el-form-item>


			<el-form-item>
				<el-button type="primary" @click="saveCoupons('editForm')">保存</el-button>
				<!-- <el-button @click="resetForm('editForm')">重置</el-button> -->
			</el-form-item>
		</el-form>

	</el-dialog>
</template>

<script>
export default {
	name: "AddUpdateCoupons",
	components: {

	},
	data() {
		return {
			// pickerOptions:{                                 //禁用当前日期之前的日期
			//     disabledDate(time) {
			//         //Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
			//         return time.getTime() < Date.now();
			//     },
			// },
			editForm: {

			},
			avatar: '',
			fileList: [],
			urlList: [],
			names: '拉新用户完成首单',
			newcomerCoupon: false,
			dialogVisible: false,

			editFormRules: {
				name: [{
					required: true,
					message: '请输入名称',
					trigger: 'blur'
				}],
				type: [{
					required: true,
					message: '请选择优惠规则类型',
					trigger: 'blur'
				}],
				discountAmount: [{
					required: true,
					message: '优惠券金额',
					trigger: 'blur'
				}],

				validTime: [{
					required: true,
					message: '请输入优惠券有效期',
					trigger: 'blur'
				}],
				// userOriented: [{
				// 	required: true,
				// 	message: '请选择指定用户',
				// 	trigger: 'blur'
				// }],

				timeLimitType: [{
					required: true,
					message: '请选择时间类型',
					trigger: 'blur'
				}],


			},
		}
	},
	methods: {
		change(val) {
			this.editForm.content = val;
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false
			this.editForm = {}
		},
		handleClose() {
			this.resetForm('editForm')
		},


		changeclassification() {
			if (this.editForm.classification == 0) {
				this.editForm.storeGoodsIdList = []
				this.editForm.storeGoodsName = ''
			} else {
				this.editForm.classificationType = undefined
			}
		},
		weihechangge(e) {
			this.$forceUpdate()
		},
		getUsers(ids, nickName) {
			this.editForm.userIdList = ids
			this.editForm.nickName = nickName
			this.$forceUpdate();
		},
		getStoreGoods(storIds, storeGoodsName) {
			// console.log('ssdddd',item)
			this.editForm.gardenIdList = storIds
			this.editForm.gardenIdName = storeGoodsName
			this.$forceUpdate();
		},
		rulesTypeChange() {
			console.log("ws====>>")
			if (this.editForm.type == 1) {
				this.editForm.satisfyAmount = 0
			} else {

			}
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if (this.editForm.newcomerCoupon == 2) {
						if (this.editForm.userIdList == null || this.editForm.userIdList.length <= 0) {
							this.$message({
								showClose: true,
								message: "请选择指定的用户",
								type: 'error',
							});
							return;
						}
					} else if (this.editForm.newcomerCoupon == 4) {
						if (this.editForm.isQuantityLimit == null || this.editForm.isQuantityLimit <=
							undefined) {
							this.$message({
								showClose: true,
								message: "请选择优惠券数量限制不限制",
								type: 'error',
							});
							return;
						}
						// if (this.editForm.receivingTime==null||this.editForm.receivingTime<=undefined){
						//     this.$message({
						//         showClose: true,
						//         message:"请填写优惠券开始领取时间",
						//         type: 'error',
						//     });
						//     return ;
						// }
						if (this.editForm.isQuantityLimit == 1 && (this.editForm.amount <= 0)) {
							this.$message({
								showClose: true,
								message: "请填写优惠券数量",
								type: 'error',
							});
							return;
						}
					}
					if (this.editForm.classification == 3) {
						if (this.editForm.gardenIdList == null || this.editForm.gardenIdList.length <= 0) {
							this.$message({
								showClose: true,
								message: "请选择园区",
								type: 'error',
							});
							return;
						}
					}

					if (this.editForm.rulesType == 0) {
						if (this.editForm.satisfyFrom == undefined || this.editForm.satisfyFrom == '' || this
							.editForm.satisfyFrom <= 0) {
							this.$message({
								showClose: true,
								message: "请填写满减条件",
								type: 'error',
							});
							return;
						}
						if (this.editForm.voucher == undefined || this.editForm.voucher == '' || this.editForm
							.voucher <= 0) {
							this.$message({
								showClose: true,
								message: "请填写满减抵扣值",
								type: 'error',
							});
							return;
						}
					} else {
						console.log("ssdddrrftdxxx", this.editForm)
						if (this.editForm.voucher == undefined || this.editForm.voucher == '' || this.editForm
							.voucher <= 0) {
							this.$message({
								showClose: true,
								message: "请填写无门槛金额",
								type: 'error',
							});
							return;
						}
					}
					if (this.editForm.newcomerCoupon == 1) {
						this.$axios.post('/sysCouponSheet/addCouponSheet').then(res => {
							if (res.data.newcomerCoupon == 0) {
								this.saveCoupons();
							} else {
								this.$confirm('已经存在未过期的新人优惠券，确定将之前的新人优惠券作废吗', '提示', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									type: 'warning'
								}).then(() => {
									this.saveCoupons(formName);
								})
							}
						})
					} else {
						this.saveCoupons(formName);
					}
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		saveCoupons(formName) {
			if (this.editForm.type == 2) {
				if (this.editForm.satisfyAmount < 0 || this.editForm.satisfyAmount == '') {
					this.$message({
						showClose: true,
						message: "请填写满减金额",
						type: 'error',
					});
					return;
				}
			}
			this.$axios.post('/admin/sysCouponSheet/add', this.editForm)
				.then(res => {
					this.$message({
						showClose: true,
						message: '恭喜你，操作成功',
						type: 'success',
						onClose: () => {

						}
					});
					this.$emit('refreshDataList')
					this.dialogVisible = false

				})
		},
		getCouponsCoverList(url, add) {
			if (add == 1) {
				this.urlList.push(url)
			} else if (add == 0) {
				if (this.urlList == null || this.urlList.length < 1) {
					return;
				}
				this.urlList.some((item, i) => {
					if (item == url) {
						this.urlList.splice(i, 1)
						//在数组的some方法中，若是return true，就会当即终止这个数组的后续循环
						return true
					}
				})
			}
			this.editForm.couponsCover = this.urlList.join(",")
		},
		init(id) {
			this.dialogVisible = true;
			if (id != null && id != '' && id > 0) {
				this.$axios.post('/admin/coupons/getCouponsInfo', {
					couponsId: id
				}).then(res => {
					this.editForm = res.data
					var termValidity = [];
					if (res.data) {
						termValidity.push(res.data.startTime)
						termValidity.push(res.data.endTime)
						this.editForm.termValidity = termValidity;
					}
				})
			} else {
				this.editForm = {
					discountAmount: '',
					name: "",
					satisfyAmount: '',
					type: 1,
					userOriented: 1,
					validTime: '',

					timeLimitType: 0
				}
			}
		},
	}
}
</script>

<style scoped>
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}

.avatar {
	width: 178px;
	height: 178px;
	display: block;
}
</style>